/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Dialog_Connect_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter your credentials to enable this integration. They are stored encrypted." |
*
* @param {Integrations_Credentials_Dialog_Connect_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_dialog_connect_description = /** @type {((inputs?: Integrations_Credentials_Dialog_Connect_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Dialog_Connect_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Ihre Zugangsdaten ein, um diese Integration zu aktivieren. Sie werden verschlüsselt gespeichert.")
	return /** @type {LocalizedString} */ ("Enter your credentials to enable this integration. They are stored encrypted.")
});